import React from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import { useTheme, Box, Typography, Button } from "@mui/material";
import { tokens } from "../../theme";

const Profile = ({ user, onLogout, onClose }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode); 
  if (!user) {
    return <Box>Loading...</Box>;  
  }

  // console.log('User data in Profile:', user); 

  const username = user?.username || "N/A";
  const email = user?.email || "N/A";
  const role = user?.role || "N/A";

  const handleLogout = () => {
    onLogout();
    navigate('/');
  };

  return (
    <Box
      m="20px"
      sx={{
        backgroundColor: theme.palette.mode === "dark" ? "#141b2d" : "#fcfcfc",
        color: theme.palette.mode === "dark" ? "#fff" : "#000",
        borderRadius: "8px",
        boxShadow: theme.palette.mode === "dark" ? "0 4px 10px rgba(255, 255, 255, 0.1)" : "0 4px 10px rgba(0, 0, 0, 0.1)",
        maxWidth: "400px",
        margin: "auto",
        padding: "20px",

      }}
      className="test"
    >
      <Box display="flex" justifyContent="space-between" >
        <Typography variant="h3" style={{ fontFamily: "Inter" }}>
          Profile
        </Typography>
        <button onClick={onClose} className="closeBtn" style={{border:'none', borderRadius:'5px'}}><CloseIcon/></button>
      </Box>

      <Box mt={2}>
        {/* Username */}
        <Typography
          variant="body1"
          sx={{
            background: theme.palette.mode === "dark" ? "#333" : "#f1f1f1",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          <strong style={{ padding: "0px 10px", fontFamily: "Inter" }}>Name :</strong> {username}
        </Typography>

        {/* Email */}
        <Typography
          variant="body1"
          sx={{
            background: theme.palette.mode === "dark" ? "#333" : "#f1f1f1",
            padding: "10px",
            borderRadius: "5px",
            mt: 1,
          }}
        >
          <strong style={{ padding: "0px 10px", fontFamily: "Inter" }}>Email :</strong> {email}
        </Typography>

        {/* Role */}
        <Typography
          variant="body1"
          sx={{
            background: theme.palette.mode === "dark" ? "#333" : "#f1f1f1",
            padding: "10px",
            borderRadius: "5px",
            mt: 1,
          }}
        >
          <strong style={{ padding: "0px 10px", fontFamily: "Inter" }}>Role :</strong> {role}
        </Typography>
      </Box>

      <Box mt={2} textAlign="center">
        {/* Logout Button */}
        <Button
          onClick={handleLogout}
          variant="contained"
          color="error"
          sx={{
            backgroundColor: "#ee3590",
            "&:hover": {
              backgroundColor: "#d32474",
            },
            padding: "8px 20px",
            borderRadius: "5px",
            fontFamily: "Inter",
          }}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );
};

export default Profile;
